(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (() => {
    const initTextReadMore = (root = document) => {
      const wrappers = root.querySelectorAll('[data-text-read-more-wrapper]');

      wrappers.forEach((wrapper) => {
        const content = wrapper.querySelector('[data-read-more-content]');
        const trigger = wrapper.querySelector('[data-read-more-trigger]');
        const triggerText = trigger?.querySelector('[data-read-more-trigger-text]');

        if (!content || !trigger || !triggerText) return;

        const collapsedHeight = Number(content.dataset.collapsedHeight || 280);
        const moreText = trigger.dataset.moreText || 'Weiterlesen';
        const lessText = trigger.dataset.lessText || 'Weniger anzeigen';

        content.style.setProperty('--read-more-collapsed-height', `${collapsedHeight}px`);

        const updateState = () => {
          const isExpanded = content.classList.contains('is-expanded');
          const isCollapsible = content.scrollHeight > collapsedHeight + 2;

          content.classList.toggle('is-collapsible', isCollapsible);
          trigger.hidden = !isCollapsible;

          if (!isCollapsible) {
            content.classList.remove('is-expanded');
            trigger.setAttribute('aria-expanded', 'false');
            triggerText.textContent = moreText;
            trigger.setAttribute('aria-label', moreText);
            content.style.removeProperty('--read-more-expanded-height');
            return;
          }

          if (isExpanded) {
            content.style.setProperty('--read-more-expanded-height', `${content.scrollHeight}px`);
          }
        };

        if (!trigger.dataset.readMoreInitialized) {
          trigger.dataset.readMoreInitialized = 'true';

          trigger.addEventListener('click', () => {
            const isExpanded = content.classList.toggle('is-expanded');

            trigger.setAttribute('aria-expanded', String(isExpanded));
            triggerText.textContent = isExpanded ? lessText : moreText;
            trigger.setAttribute('aria-label', isExpanded ? lessText : moreText);

            if (isExpanded) {
              content.style.setProperty('--read-more-expanded-height', `${content.scrollHeight}px`);
            }
          });
        }

        requestAnimationFrame(updateState);
      });
    };

    initTextReadMore();

    window.addEventListener('resize', () => {
      initTextReadMore();
    });

    document.addEventListener('shopify:section:load', (event) => {
      initTextReadMore(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      initTextReadMore(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
